import { FC } from 'react';
import stepIcon from '../../../Assets/StepIcons/Parallel.png';
import { NodeLibraryListItem } from '../../Components/NodeLibraryListItem';
import { NodeTypes, PARALLEL_NODE_DESCRIPTION } from '../../utils';

export const ParallelNodeLibraryListItem: FC = () => {
    return <NodeLibraryListItem label='Parallel' description={PARALLEL_NODE_DESCRIPTION} nodeType={NodeTypes.PARALLEL} imgPath={stepIcon} />
}